// extracted by mini-css-extract-plugin
export default {"notice":"Notice_notice__6H7VW","noticeText":"Notice_noticeText__8IQJA"};